import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { proveedorApi } from "@/features/proveedor/services/proveedor.api";

export const proveedoresAgrupadosQueryOptions = (solicitudId: string) =>
  queryOptions({
    queryKey: qk.proveedoresAgrupados(solicitudId),
    queryFn: () => proveedorApi.consultarAgrupados(solicitudId),
    staleTime: 30_000,
  });

export function useProveedoresAgrupados(solicitudId: string) {
  return useSuspenseQuery(proveedoresAgrupadosQueryOptions(solicitudId));
}
